// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ErrorInformationStorage } from "../../Commons/ErrorInformationStorage.js"
import { Resources } from "../../Commons/properties/Resources.js"
import { LinkedSystem, LinkedSystemAccLinkingValue } from "../misc/LinkedSystem.js"
import { Control } from "../elements/Control.js"
import { TerceraQuickTree } from "../elements/QuickTree/TerceraQuickTree.js"
import { TerceraLinkControlConstants } from "../UtilsClasses/TerceraLinkControlConstants.js"
import { TerceraMenu } from "../elements/TerceraMenu.js"
import { TradingButtonStripe } from "../elements/TradingButtonStripe.js"
import { EditPositionScreen } from "../screen/EditPositionScreen.js"
import { ModifyOrderScreen } from "../screen/ModifyOrderScreen.js"
import { TerceraMessageBox } from "../screen/TerceraMessageBox.js"
import { ApplicationPanelNew } from "./ApplicationPanelNew.js";
import { DynProperty } from "../../Commons/DynProperty.js"
import { IsAllowedResponceReason } from "../../Commons/IsAllowed.js"
import { ApplicationInfo } from "../../Commons/ApplicationInfo.js"
import { TradingLockUtils } from "../../Utils/TradingLockUtils.js"


export let OrdersPanelBase = ApplicationPanelNew.extend({
    topPanelHeight: 25,
    Name: 'OrdersPanelBase',
    data: function ()
    {
        return {
            isAccountLinkShow: true,
            isSymbolLinkShow: true,
            isShowExploreTheAppLink: ApplicationInfo.isExploreMode
        }
    },
    headerLocaleKey: '',
    ToolbarVisible: false,
    doubleClickedTimerID: null
})

OrdersPanelBase.UPDATE_ALLOWED_ACTIONS_MILLIS = 500

OrdersPanelBase.prototype.getType = function () { throw new Error('Not implemented') }

OrdersPanelBase.prototype.getDoubleClickActionParams = function ()
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.getHotButtonPlacedFrom = function ()
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.getFullInstrumentName = function (rowItem)
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.getAccount = function (rowItem)
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.DCEventsSubscribe = function ()
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.DCEventsUnSubscribe = function ()
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.createMenuItems = function ()
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.createTradingButtonItems = function ()
{
    throw new Error('Not implemented')
}

OrdersPanelBase.prototype.updateAllowedActions = function ()
{
    throw new Error('Not implemented')
}

// TODO. Rename.
OrdersPanelBase.prototype.action = function (action)
{
    if (TradingLockUtils.TradingLock.tradingLocked) { return false; }

    if (!this.quickTableRactive || !this.quickTableRactive.quickTable) { return false; }

    if (this.isClosingAction(action) && this.IsClosingForbidden(this.quickTableRactive.quickTable.selectedRowIds)) { return false; }

    return true;
}

OrdersPanelBase.prototype.isClosingAction = function (action)
{
    throw new Error('Not implemented')
}

// TODO. Ugly.
OrdersPanelBase.prototype.onDrawCell = function (gr, e) { }

OrdersPanelBase.prototype.oninit = function ()
{
    ApplicationPanelNew.prototype.oninit.call(this)
    this.updateAllowedActions = this.updateAllowedActions.bind(this)
}

OrdersPanelBase.prototype.oncomplete = function ()
{
    ApplicationPanelNew.prototype.oncomplete.call(this)

    let qt = this.quickTableRactive.quickTable

    let menuItems = this.createMenuItems()
    this.menuTagDict = TerceraMenu.createTagDictionary(menuItems)
    qt.setTableContextMenuItems(menuItems)

    qt.OnSelectionChanged.Subscribe(this.selectionChange, this)
    qt.OnDrawCell.Subscribe(this.onDrawCell, this)

    this.quickTableRactive.on(TerceraQuickTree.Events.DoubleClick, this.onDoubleClicked.bind(this))
    this.quickTableRactive.quickTable.OnPaintedPictureButtonClick.Subscribe(this.CloseBtnClick, this);

    let btns = new TradingButtonStripe()
    btns.set('name', 'btns')
    this.addControl(btns)
    btns.setItemArray(this.createTradingButtonItems())
    btns.on('tradingAction', this.onTradingButtonClick.bind(this))

    if (this.DelayProperties)
    {
        btns.setBtnsVisibility(this.DelayProperties);
        this.DelayProperties = null;
    }
    this.UpdateToolbarVisibility(this.ToolbarVisible);
    this.localize()
    this.DCEventsSubscribe()
    this.updateAllowedActions()
}

OrdersPanelBase.prototype.ShowToolbarStateChange = function (menuItem)
{
    this.UpdateToolbarVisibility(menuItem.checked);
}
OrdersPanelBase.prototype.UpdateToolbarVisibility = function (state)
{
    this.Controls.btns.set("visible", state);
    this.topPanelHeight = state ? 25 : 0;
    this.layoutTable();
    this.ToolbarVisible = state
}

OrdersPanelBase.prototype.CloseBtnClick = function (data)
{

}

OrdersPanelBase.prototype.IsClosingAllowed = function () { }

OrdersPanelBase.prototype.IsClosingForbidden = function (selectedOrderIdArr) 
{
    const isAllowed = this.IsClosingAllowed(selectedOrderIdArr);

    if (isAllowed.Allowed)
        return false;

    const title = Resources.getResource('MessageBox.ThemeChanged.Title');
    const reason = isAllowed.ReasonText;
    TerceraMessageBox.Show(title, reason, TerceraMessageBox.msgType.Warning, null, null, false, true);
    return true
}

OrdersPanelBase.prototype.onDoubleClicked = function ()
{
    let params = this.getDoubleClickActionParams()

    let qt = this.quickTableRactive.quickTable
    if (!qt) return
    let selectedOrderIdArr = qt.selectedRowIds

    if (this.IsClosingForbidden(selectedOrderIdArr))
        return

    let screen = ModifyOrderScreen.getScreenByOrderID(selectedOrderIdArr[0])

    if (!screen)
    {
        let qtItem = qt.getItemById(selectedOrderIdArr[0]), posID
        if (qtItem && qtItem.item && qtItem.item.FOrder)
            posID = qtItem.item.FOrder.PositionId                       // достаем PositionId
        screen = EditPositionScreen.getScreenByPositionID(posID)        // чтобы найти открытый EditPositionScreen при клике на S/L(T/P) в панеле Working orders
    }

    if (screen && !screen.NotSkipNextTime)  // TODO !!!
    {
        screen.NotSkipNextTime = true;      // ЕБАНЫЙ КОСТЫЛЬ
        return;
    }

    let timerID = this.doubleClickedTimerID

    if (timerID)
        clearTimeout(timerID);

    this.action(params.action, params.confirm, params.placedFrom)
}

OrdersPanelBase.prototype.dispose = function ()
{
    ApplicationPanelNew.prototype.dispose.call(this)
    this.DCEventsUnSubscribe()
    this.quickTableRactive.quickTable.OnDrawCell.UnSubscribe(this.onDrawCell, this)
}

// TODO. Ugly.
OrdersPanelBase.prototype.onMouseDown = function (event, isHeader)
{
    if (Control.IsEventProcessed(event))
        return

    let btns = this.Controls.btns

    let offsetY = event.original.offsetY
    if (offsetY <= 0 || offsetY >= 30 || !btns)
    {
        ApplicationPanelNew.prototype.onMouseDown.call(this, event, isHeader)
        Control.ProcessEvent(event)
        return
    }

    if (btns && !btns.get("visible")) return;

    btns.onMouseDown(event, isHeader)
}

OrdersPanelBase.prototype.selectionChange = function ()
{
    let qt = this.quickTableRactive.quickTable
    let selectedRowsId = qt.selectedRowIds
    if (!selectedRowsId) return

    let insId = ''
    //let accId = ''

    if (selectedRowsId.length > 0)
    {
        let row = qt.rows[selectedRowsId[0]]
        let item = row ? row.item : null
        if (item)
        {
            let ins = item.GetCurrentInstrument()
            if (ins) insId = ins.GetInteriorID()

            //let acc = item.GetCurrentAccount()
            //if (acc) accId = acc.BstrAccount
        }
    }

    this.symbolLink_Out(false, insId)
    //this.accountLink_Out(false, accId)
    this.updateAllowedActions()
}

OrdersPanelBase.prototype.accountLink_Out = function (newSubscriber, account)
{
    if (!account)
        return

    if (LinkedSystem.accLinkingActive)
        LinkedSystem.setAccount(LinkedSystemAccLinkingValue, account, newSubscriber);
}

OrdersPanelBase.prototype.symbolLink_Out = function (newSubscriber, instrument)
{
    if (!instrument)
        return

    let color = this.get('symbolLinkValue')
    if (color !== TerceraLinkControlConstants.STATE_NONE)
        LinkedSystem.setSymbol(color, instrument, newSubscriber)
}

OrdersPanelBase.prototype.getSelectedInstrumentID = function ()
{
    var ins = this.getInstrument(),
        result = ''

    if (ins)
        result = ins.GetInteriorID()

    return result
}

OrdersPanelBase.prototype.localize = function ()
{
    ApplicationPanelNew.prototype.localize.call(this)

    let menuTagDict = this.menuTagDict
    if (!menuTagDict) return

    for (let key in menuTagDict)
    {
        let menuItem = menuTagDict[key]
        menuItem.text = Resources.getResource(menuItem.locKey)
    }
}

OrdersPanelBase.prototype.onTradingButtonClick = function (action)
{
    this.action(action, false, this.getHotButtonPlacedFrom())
}

OrdersPanelBase.prototype.Properties = function ()
{
    var properties = ApplicationPanelNew.prototype.Properties.call(this);

    let btns = this.Controls.btns
    if (btns)
    {
        let btnProp = btns.getBtnsVisibility();
        properties.push(new DynProperty("BtnsVisibility", JSON.stringify(btnProp), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    }

    properties.push(new DynProperty("ToolbarVisible", this.ToolbarVisible, DynProperty.BOOLEAN, DynProperty.HIDDEN_GROUP));

    return properties;
};

OrdersPanelBase.prototype.callBack = function (newProperties)
{
    ApplicationPanelNew.prototype.callBack.call(this, newProperties);

    let btnsVisibility = DynProperty.getPropValue(newProperties, "BtnsVisibility");
    if (btnsVisibility)
    {
        try
        {
            btnsVisibility = JSON.parse(btnsVisibility);
        }
        catch (ex)
        {
            ErrorInformationStorage.GetException(ex);
            btnsVisibility = [];
        }
        if (this.Controls.btns)
            this.Controls.btns.setBtnsVisibility(btnsVisibility);
        else
            this.DelayProperties = btnsVisibility;
    }

    let toolbarVisible = DynProperty.getPropValue(newProperties, "ToolbarVisible");
    if (toolbarVisible != null)
    {
        this.ToolbarVisible = toolbarVisible
    }
};